import { EventListener } from '../Services/event-listener';
import { IWindowProvider } from '../Services/event-listener.interface';
import { IAppDefinition, ICommunicationBridge } from '../Services/hosted-web-content-sdk.interface';
import {
  IFrameInfo,
  IWebContentMessageEvent,
  IWebContentRequestMessage,
  IWebContentResponseMessage,
} from '../Services/messages.interface';
import { isValidUrlForApp } from '../Services/utils';

export class IframeCommunicationBridge implements ICommunicationBridge {
  private hostEventListener?: EventListener;
  private handleMessageCallbackIframe?: (event: IWebContentMessageEvent) => void;

  private origin?: string;
  private frame?: IFrameInfo;
  private appDefinition?: IAppDefinition;

  public onSdkInitialized(hostWindow: Window | IWindowProvider) {
    this.hostEventListener = new EventListener(hostWindow);
    this.hostEventListener.addListener('message', this.onMessageReceived.bind(this));
  }

  public onSetFrameAndLoadOrigin(
    frame: IFrameInfo,
    origin: string,
    appDefinition: IAppDefinition,
    handleMessageCallback: (event: IWebContentMessageEvent) => void
  ) {
    this.frame = frame;
    this.origin = origin;
    this.appDefinition = appDefinition;
    this.handleMessageCallbackIframe = handleMessageCallback;
  }

  public postMessage(
    target: HTMLIFrameElement | IFrameInfo,
    message: IWebContentRequestMessage | IWebContentResponseMessage
  ) {
    if (this.origin) {
      if (target.contentWindow) {
        target.contentWindow.postMessage(message, this.origin);
      }
    }
  }

  public onMessageReceived(event: MessageEvent<any>) {
    // The message event originated from an unknown frame
    if (!this.frame || this.frame.contentWindow !== event.source) {
      return;
    }

    const sourceOrigin = event.origin;
    if (sourceOrigin !== this.origin && isValidUrlForApp(sourceOrigin, this.appDefinition)) {
      this.origin = event.origin;
    }
    if (this.origin === sourceOrigin && this.handleMessageCallbackIframe) {
      this.handleMessageCallbackIframe(event);
    }
  }

  public dispose(): void {
    this.hostEventListener?.removeAllListeners();
  }
}
